module.exports = {
    "Empty": `Prazno`
};


//# sourceMappingURL=hr-HR.main.js.map
